import React,{useState} from 'react';
import ChildrensBookManuscriptEditor from './ChildrensBookManuscriptEditor';
import {
  sceneFirstMatterV1E6B2, addSceneFirstMatterV1E6B2,
  editSceneFirstMatterV1E6B2,sceneFirstMatterTemplatesV1E6B2,
} from '../utils/childrensBookSceneFirstMatterV1E6B2';

const makeId=kind=>'cb-matter-'+kind+'-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,10);
export default function ChildrensBookSceneFirstMatterV1E6B2({
  draft={},kind='front',lang='en',readOnly=false,onChangeMatter,
}) {
  const fr=String(lang).toLowerCase().startsWith('fr');
  const [openedId,setOpenedId]=useState('');
  const [error,setError]=useState('');
  const [customTitle,setCustomTitle]=useState('');
  const current=sceneFirstMatterV1E6B2(draft);
  const permitted=['front','back'].includes(kind) && current.ok;
  const rows=permitted?current.matter[kind]:[];
  const section=kind==='front'?(fr?'Pages liminaires':'Front Matter'):(fr?'Éléments de fin':'Back Matter');
  function add(title) {
    const result=addSceneFirstMatterV1E6B2(draft,kind,makeId(kind),title);
    if(!result.ok) {setError(result.code);return;}
    const list=result.matter[kind];
    setOpenedId(list[list.length-1].id);setError('');setCustomTitle('');
    onChangeMatter?.(result.matter);
  }
  function change(id,patch) {
    const result=editSceneFirstMatterV1E6B2(draft,kind,id,patch);
    if(!result.ok) {setError(result.code);return;}
    setError('');onChangeMatter?.(result.matter);
  }
  return <section className="ns-card" data-cb-v1e6b2-matter={kind}
      style={{padding:22,borderRadius:18,border:'1px solid #cbd5e1',display:'grid',gap:16}}>
    <div style={{display:'grid',gap:6}}>
      <div className="ns-card-meta" style={{fontWeight:800,color:'#047857'}}>
        {fr?'CONTENU DU LIVRE':'BOOK CONTENT'} · {section.toUpperCase()}
      </div>
      <h3 className="ns-section-title" style={{margin:0}}>{section}</h3>
      <p className="ns-card-meta" style={{margin:0}}>{fr
        ?'Rédigez chaque rubrique avec l’éditeur du manuscrit. Les rubriques restent distinctes des scènes et des pages.'
        :'Choose an optional section, then write using the existing manuscript editor. These items remain separate from Scenes and physical pages.'}</p>
      <p className="ns-card-meta" style={{margin:0,fontWeight:700}}>{fr
        ?'Utilisez « Enregistrer les modifications » au-dessus pour conserver votre texte.'
        :'Use Save Changes above to persist your text. No separate save or publication action.'}</p>
    </div>
    {!permitted ? <p role="alert" data-cb-v1e6b2-matter-unavailable="true">{fr
      ?'Ce livre utilise encore l’ancien modèle. Aucun contenu ne sera modifié.'
      :'Logical Front/Back Matter is available only for Scene-first books; existing page-based books remain unchanged.'}</p>:null}
    {permitted && !readOnly ? <div style={{display:'grid',gap:9}}>
      <strong>{fr?'Ajouter une rubrique facultative':'Add an optional section'}</strong>
      <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
        {sceneFirstMatterTemplatesV1E6B2[kind].map(label=><button key={label}
          type="button" className="ns-button ns-button-outline" onClick={()=>add(label)}
          disabled={rows.some(row=>row.title===label)}>{label}</button>)}
      </div>
      <label style={{display:'grid',gap:5,maxWidth:490}}>{fr?'Titre personnalisé':'Custom section title'}
        <input className="ns-input" value={customTitle} maxLength={240}
          onChange={e=>setCustomTitle(e.target.value)} />
      </label>
      <button className="ns-button ns-button-outline" type="button"
        disabled={!customTitle.trim()} onClick={()=>add(customTitle.trim())}>
        {fr?'Ajouter une rubrique personnalisée':'Add Custom Section'}</button>
    </div>:null}
    {error?<p role="alert">{error}</p>:null}
    {permitted && rows.length===0 ? <p className="ns-card-meta">{fr
      ?'Aucune rubrique ajoutée. Vous pouvez commencer par la dédicace ou la préface.'
      :'Nothing added yet. A dedication or preface is a common starting point.'}</p>:null}
    {permitted ? <div style={{display:'grid',gap:12}}>
      {rows.map((item,index)=>{
        const opened=openedId===item.id;
        return <div key={item.id} data-cb-v1e6b2-matter-item={item.id}
          style={{border:'1px solid #d1d5db',borderRadius:12,padding:14,display:'grid',gap:10}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:10,flexWrap:'wrap'}}>
            <strong>{index+1}. {item.title}</strong>
            <button type="button" className="ns-button ns-button-outline"
              onClick={()=>setOpenedId(opened?'':item.id)}>
              {opened?(fr?'Fermer':'Close'):(fr?'Modifier le contenu':'Edit Content')}
            </button>
          </div>
          {opened?<div style={{display:'grid',gap:10}}>
            <label style={{display:'grid',gap:4,maxWidth:530}}>{fr?'Titre de la rubrique':'Section title'}
              <input className="ns-input" value={item.title} maxLength={240} disabled={readOnly}
                onChange={e=>change(item.id,{title:e.target.value})}/>
            </label>
            <ChildrensBookManuscriptEditor key={item.id} lang={lang}
              entry={{id:item.id,manuscriptContent:item.manuscriptContent}}
              disabled={readOnly} saveActionLabel={fr?'Enregistrer les modifications':'Save Changes'}
              onChange={fields=>!readOnly && change(item.id,{manuscriptContent:fields.manuscriptContent})}/>
          </div>:null}
        </div>;
      })}
    </div>:null}
    <p className="ns-card-meta" style={{margin:0}}>{fr
      ?'Les suppressions et la préparation PDF ne sont pas activées dans cette étape.'
      :'Removal and PDF layout remain locked in this pilot. Existing content is never silently deleted.'}</p>
  </section>;
}
